import { Component, Injectable, Type } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { delay, of, switchMap } from 'rxjs';


@Injectable()
export class ModalService {
  public action: string = ''
  
  constructor(public dialogService: DialogService) { }

  public show(component: Type<any>, header: string, data: any = undefined, dynamicStyleClass: string = 'dialogComponent' ) {
    return this.dialogService.open(component, {
      header: header,
      width: '70%',
      style: {
        'height': 'auto',
        'max-height': '98vh'
      },
      baseZIndex: 10000,
      dismissableMask: false,
      styleClass: dynamicStyleClass ,
      data: data
    });
  }

  public showModal(component: Type<any>, header: string, data: any = undefined) {
    return of(this.closeAll()).pipe(
      delay(200),
      switchMap(() => of(this.dialogService.open(component, {
        header: header,
        width: '70%',
        style: {
          'height': 'auto',
          'max-height': '98vh'
        },
        baseZIndex: 10000,
        dismissableMask: false,
        styleClass: 'dialogComponent' ,
        data: data
      })))
     )
  }

  public closeAll() {
    this.dialogService.dialogComponentRefMap.forEach(dialog => {
      dialog.destroy();
    });
  }

  public changeHeader( header: string, position: number = 0 ) {
    document.getElementsByClassName('p-dialog-title')[position].innerHTML = header
  }

  public calledfor(action: string) {
    this.action = action
  }

}
